import { Component, computed, ElementRef, inject, OnInit, ViewChild } from '@angular/core';
import { SidebarService } from '../sidebar/sidebar.service';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { UserDropdownComponent, UserInfo, UserStateService, SchemaMembershipStateService } from '@net3-multiplatform-client/libs';
import { AuthService } from '../../../features/auth/services/auth.service';

@Component({
  selector: 'app-header',
  imports: [
    CommonModule,
    RouterModule,
    UserDropdownComponent,
  ],
  templateUrl: './header.component.html',
})
export class AppHeaderComponent implements OnInit {
  private authService = inject(AuthService);

  isApplicationMenuOpen = false;
  readonly isMobileOpen$;

  @ViewChild('searchInput') searchInput!: ElementRef<HTMLInputElement>;

  userState = inject(UserStateService);
  schemaState = inject(SchemaMembershipStateService);
  user = this.userState.user;
  membership = this.schemaState.schema;

  showButtonBack = computed(() => (this.user()?.memberships?.length ?? 0) > 1);

  constructor(public sidebarService: SidebarService) {
    this.isMobileOpen$ = this.sidebarService.isMobileOpen$;
  }

  async ngOnInit(): Promise<void> {
  }

  handleToggle() {
    if (window.innerWidth >= 1280) {
      this.sidebarService.toggleExpanded();
    } else {
      this.sidebarService.toggleMobileOpen();
    }
  }

  toggleApplicationMenu() {
    this.isApplicationMenuOpen = !this.isApplicationMenuOpen;
  }

  ngAfterViewInit() {
    document.addEventListener('keydown', this.handleKeyDown);
  }

  ngOnDestroy() {
    document.removeEventListener('keydown', this.handleKeyDown);
  }

  handleKeyDown = (event: KeyboardEvent) => {
    if ((event.metaKey || event.ctrlKey) && event.key === 'k') {
      event.preventDefault();
      this.searchInput?.nativeElement.focus();
    }
  };

  onSignOut(){
    this.authService.logout();
  }
}
